import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './rootReducer';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './rootSaga';
import { routerMiddleware } from 'react-router-redux';
import history from '../history';

const middleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const composeEnhancers =
    process.env.NODE_ENV === 'production' ? compose :
        (typeof window === 'object' &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose);

const enhancer = composeEnhancers(
    applyMiddleware(middleware, sagaMiddleware),
);

const configureStore = (initialState, context = {}) => {
    return {
        ...createStore(rootReducer, initialState, enhancer),
        runSaga: sagaMiddleware.run(rootSaga, context)
    };
};

export default configureStore;